import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "passwordResetSuccess",
  "use": "passwordResetSuccess-usage",
  "viewBox": "0 0 104 104",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 104 104\" id=\"passwordResetSuccess\"><g data-name=\"icon - big checkmark - 104px\" transform=\"translate(-8 -8.199)\"><circle cx=\"52\" cy=\"52\" r=\"52\" transform=\"translate(8 8.199)\" fill=\"#031425\" /><path data-name=\"↳ color\" d=\"M88.342 46.085L54.085 80.342a4.522 4.522 0 0 1-6.44 0L31.658 64.356a4.554 4.554 0 0 1 6.44-6.44l12.767 12.743 31.037-31.014a4.554 4.554 0 1 1 6.44 6.44z\" fill=\"#fff\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol